import LicenciasVencidasDataBorrado from './LicenciasVencidasDataBorrado/index';

export default LicenciasVencidasDataBorrado;
